export default __webpack_public_path__ + "static/koen-cv-6cd8f128ec6692b1adb45f7b038e0f5a.png";